import React from 'react';
import './menu.scss';

import PropTypes from 'prop-types';
import classNames from 'classnames';

const Menu = ({ items, className }) => (
  <ul className={classNames('menu', className)}>
    {items.map((menuItem) => (
      <li
        className="menu__item"
        role="presentation"
        key={menuItem.href}
      >
        <a
          className="menu__link"
          role="menuitem"
          tabIndex="-1"
          href={menuItem.href}
          onClick={menuItem.onClick}
        >{menuItem.label}
        </a>
      </li>
    ))}
  </ul>
);

export const MenuItemsType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  href: PropTypes.string,
}));

Menu.propTypes = {
  items: MenuItemsType,
  className: PropTypes.string,
};

Menu.defaultProps = {
  items: [],
  className: undefined,
};

export default Menu;
